document.addEventListener('DOMContentLoaded', function () {
  const updateAll = () => {
    const contactForm = document.querySelector('.contact-form>form');
    if (!contactForm) return;

    const selectedVariants = {};
    const fieldsets = document.querySelectorAll('fieldset.variant-picker__option');
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend');
      if (!legend) return;

      const fieldsetKey = legend.textContent.trim().replace(":", "").toLowerCase();
      const inputs = fieldset.querySelectorAll('input');

      const selectedLabels = Array.from(inputs)
        .filter(input => input.checked)
        .map(input => {
          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          return label ? label.textContent.trim() : '';
        })
        .filter(label => label !== '');

      selectedVariants[fieldsetKey] = selectedLabels;

      // Verwijder bestaande hidden inputs
      const existing = contactForm.querySelectorAll(`[data-variant-hidden="${fieldsetKey}"]`);
      existing.forEach(el => el.remove());

      // Voeg nieuwe hidden inputs toe
      selectedLabels.forEach((value, index) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `contact[variant_${fieldsetKey}]`;
        input.value = value;
        input.setAttribute('data-variant-hidden', fieldsetKey);
        contactForm.appendChild(input);
      });
    });

    console.log('Selected variants:', selectedVariants);
  };

  // Initial update
  updateAll();

  // Event delegation: luister op documentniveau
  document.addEventListener('change', function (e) {
    if (
      e.target.matches('fieldset.variant-picker__option input[type="radio"]') ||
      e.target.matches('fieldset.variant-picker__option input[type="checkbox"]')
    ) {
      updateAll();
    }
  });
});